module.exports = __webpack_public_path__ + "static/media/growth-up_1.53ac75de.svg";